import _ from 'underscore';
import Person from 'edge/quoteandbind/common/models/Person';
import EntityUtil from 'gw-portals-util-js/EntityUtil';
import PolicyLineExtensionConfiguration from 'integration/quoteandbind/PolicyLineExtensionConfiguration';

function Submission(data) {
    if (data) {
        if (typeof data !== 'string') {
            this._constructWithData(data);
        } else {
            this._constructWithLob(data);
        }

        PolicyLineExtensionConfiguration.mixinLobDataExtensions(this);
    } else {
        this._constructNew();
    }
}

Submission.prototype._constructNew = function () {
    this.persons = [];

    var startYear = new Date();
    this.baseData = {
        accountHolder: {
            subtype: 'Person',
            accountHolder: true
        },
        periodStartDate: {
            year: startYear.getFullYear(),
            month: startYear.getMonth(),
            day: startYear.getDate()
        },
        questionSetNames: []
    };
    this.lobData = {};
};

Submission.prototype._constructWithLob = function (lob) {
    this._constructNew();
    this.baseData.productCode = lob;
};

Submission.prototype._constructWithData = function (data) {
    data.persons = [];

    data.baseData.accountHolder = this._forcePerson(data, data.baseData.accountHolder);
    if (data.baseData.accountHolder) {
        if (!data.baseData.accountHolder.subtype) {
            data.baseData.accountHolder.subtype = 'Person';
        }
        data.baseData.accountHolder.accountHolder = true;

        // Sanitisation for data coming from core products. This can cause problems returning to backend
        ['prefix', 'suffix', 'middleName'].forEach(function (key) {
            data.baseData.accountHolder[key] = undefined;
        });
    }

    _.extend(this, data);
    this.persons.forEach(function (p) {
        ['prefix', 'suffix', 'middleName'].forEach(function (key) {
            p[key] = undefined;
        });
    });
    if (data.quoteData && data.quoteData.offeredQuotes) {
        this.quoteData.offeredQuotes = data.quoteData.offeredQuotes.map(function (quote) {
            // include coverages in quote object
            quote.lobs = _.mapObject(data.lobData, function (lobdata) {
                if (lobdata.coverages) {
                    return lobdata.coverages;
                }
                if (lobdata.offerings) {
                    var offering = lobdata.offerings.find(function (offer) {
                        return offer.branchName === quote.branchName;
                    });
                    return offering ? offering.coverages : null;
                }
            });
            return quote;
        });
    }
};

Submission.prototype.createId = function () {
    return EntityUtil.nextId();
};

Submission.prototype.nextId = function () {
    return EntityUtil.nextId();
};

Submission.prototype.createPerson = function () /* options*/{
    var person = new Person({
        tempId: EntityUtil.nextId()
    });
    this.persons.push(person);
    return person;
};

// UTILS
Submission.prototype.getAccountHolderPerson = function () {
    return this.baseData.accountHolder;
};

Submission.prototype.submissionExists = function () {
    return !!this.quoteID;
};

Submission.prototype.findPerson = function (submission, person) {
    if (_.isEmpty(person)) {
        return null;
    }

    return this._forcePerson(submission, person);
};

Submission.prototype._forcePerson = function (submission, person) {
    var p = person.publicID ? _.findWhere(submission.persons, {
        publicID: person.publicID
    }) : null;
    if (!p) {
        p = new Person(person);
        p.tempId = EntityUtil.nextId();
        submission.persons.push(p);
    }
    return p;
};

export default Submission;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/models/Submission.js
// module id = 35
// module chunks = 0